export type AuditAction = 'created' | 'updated' | 'deleted'
export type AuditSource = 'dashboard' | 'mcp' | 'api' | 'admin'

export const STAFF_MASK = 'convious-staff'

export interface AuditLogEntry {
    id: number
    createdAt: string
    objectType: string
    action: AuditAction
    objectId: string
    objectName: string | null
    actor: string | null
    impersonatedBy: string | null
    isAdmin: boolean
    source: AuditSource
    correlationId: string | null
    stateBefore: Record<string, unknown> | null
    stateAfter: Record<string, unknown> | null
}

export interface AuditLogQuery {
    from?: string
    to?: string
    objectType?: string
    objectId?: string
    actor?: string
    source?: string
    cursor?: string
    pageSize?: number
}

export const OBJECT_TYPE_LABELS: Record<string, string> = {
    timeslot_group: 'Time slot group',
    opening_times: 'Opening times',
    opening_times_exception: 'Opening times exception',
    article: 'Product',
    products_list: 'Product list',
    validity_override: 'Validity override',
    price_settings: 'Price settings',
    price_override: 'Price override',
}

export const SOURCE_LABELS: Record<AuditSource, string> = {
    dashboard: 'Control panel',
    mcp: 'Convious AI',
    api: 'API',
    admin: 'Convious admin',
}
